<template>
  <div class="bg_white pb48">
    <Mv />
    <!-- <h1 class="content_title">加入プラン・購入金額お支払方法の確認</h1> -->
    <div class="comfirm pl15 pr15 mt20">
      <p class="page_title ab">NP FAN CLUB  契約プラン</p>
      <div class="price">
        <div class="pb24">
          <div class="priceList mt5">
            <p class="price_title ar">{{ fanClubSelectPlanName }}</p>
          </div>
          <div class="priceList mt5">
            <p class="price_title ar">税込</p>
            <p class="price_number rb"><span class="yen">￥</span>{{ fanClubsSelectPlanPrice.toLocaleString() }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="payment pl15 pr15">
      <p class="page_title ab">お支払方法</p>
      <div class="payment_wrap">
        <label for="credit" class="payment_title ar">クレジットカード</label>
        <input @change="setFanClubCreditData" id="credit" class="autoComplete__input" type="text" name="payment" :value="fanClubCreditCardNumber">
      </div>
    </div>
    <div class="btn_wrap">
      <div class="pr15 pl15">
        <p class="alert ab">※「決済する」ボタンが押されますと、処理を開始します。</p>
        <p class="alert ab">※「決済する」ボタンは2度押さず、ブラウザ更新ボタンなども押さぬようお願い致します。</p>
      </div>
      <button @click.stop.prevent="settlement()" class="btn_blue confirm_btn">決済する</button>
      <router-link class="btn_delete confirm_btn" :to="{ name: 'fanClubRegisterSelectPlan' }">戻る</router-link>
    </div>
    <Loading v-show="loading" />
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Mv from '@/components/fanClub/RegisterMv'
import creditCard from '@/components/api/creditCard'
import FanClub from '@/components/api/fanClub'
import Loading from '@/components/common/Loading'
import ErrorModal from '@/components/common/ErrorModal'
import scrollPosition from '@/model/scrollPosition';

export default {
  components: { Mv, Loading, ErrorModal },
  data() {
    return {
      loading: false,
      isModalOpen: false,
      errorMessage: 'aa',
    }
  },
  methods: {
    setFanClubCreditData(n) {
      this.$store.commit('setFanClubCreditCardNumber', n.target.value);
    },
    setFanClubCreditCardNumber(cardNo) {
      this.$store.commit('setFanClubCreditCardNumber', cardNo);
    },
    setFanClubCreditCardId(creditCardId) {
      this.$store.commit('setFanClubCreditCardId', creditCardId);
    },
    setFanClubOrderId(orderId) {
      this.$store.commit('setFanClubOrderId', orderId);
    },
    settlement() {
      this.loading = true;
      // 送信
      if(this.fanClubCreditCardNumber) {
        FanClub.apply(this.fanClubCreditId, this.fanClubSelectPlanId).then((val) => {
          console.log(val);
          if(val.status == 'OK') {
            this.loading = false;
            this.setFanClubOrderId(val.orderId)
            this.$router.push({ name: 'fanClubRegisterComplete' });
          } else {
            this.loading = false;
            this.isModalOpen = true;
            this.errorMessage = '登録に失敗しました';
          }
        });
        // this.$router.push({ name: 'fanClubRegisterComplete' });
      } else {
        this.loading = false;
        this.isModalOpen = true;
        this.errorMessage = '登録に失敗しました';
      }
    },
    async apiGetCreditCardList() {
      await creditCard.getCreditCardList('001').then((val) => {
        console.log(val);
        let selectable = val.creditCardList.find((value) => value.selected);
        this.setFanClubCreditCardNumber(selectable.cardNo);
        this.setFanClubCreditCardId(selectable.creditCardId);
        // this.setFanClubCreditCardNumber(val.creditCardList[3].cardNo);
        // this.setFanClubCreditCardId(val.creditCardList[3].creditCardId);
      });
    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    }
  },
  computed: mapGetters(['fanClubSelectPlanId', 'fanClubSelectPlanName', 'fanClubsSelectPlanPrice', 'fanClubCreditId', 'fanClubCreditCardNumber']),
  created() {
    !this.fanClubCreditCardNumber? this.apiGetCreditCardList() : '';
  }
}
</script>

<style lang="css" scoped>
.content_title {
  max-width: 290px;
}

.price {
  margin-top: 20px;
}

.priceList {
  display: flex;
  justify-content: space-between;
}

.price_title {
  font-size: 14px;
}
.price_number {
  font-size: 16px
}

.yen {
  font-size: 12px;
}

.payment {
  margin-top: 50px;
}

.payment_wrap {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.payment_title {
  font-size: 14px;
}

.btn_wrap {
  margin-top: 45px;
}

.alert {
  color: #FF0404;
  font-size: 14px;
}

.confirm_btn {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/register/Confirm.vue